

<section id="services" class="section-bg">
    <div class="container">

        <header class="section-header">
            <h1 style="text-align: center;">Open Positions</h1>
            <p>We are always looking for new talented people to join our team. If your skillset matches with the positions listed below, email your to career@shreemon.com</p>
          </header>
      <div class="row">

        <div class="col-md-6 col-lg-6  wow bounceInUp" data-wow-duration="1.4s">
          <div class="box" style="padding: 20px">
           
            <h4 class="title"><a>Software Developer</a></h4>
            <div class="description">
                <div><div><h6><b>Overview</b>
                  </h6><div><div><div><p>This position is responsible for integrating applications through web applications. This position will also work closely with 
                    all internal departments (operations, marketing, customer service and technical experts) to ensure that enterprise integrations 
                    are working as expected.</p>
                  </div></div></div><h6 ><b>Responsibilities
                  </b></h6><div><div><div><ul><li>Design and development of applications/web solutions using .NET C#, XML, Java script, HTML as per business requirements.
                  </li><li>Creating web applications communicating with Databases like SQL, Oracle, etc..</li><li>
                  Following all required software development standards, change control procedures, and security requirements within the company.</li><li>
                  Assisting in the formulation of business and testing requirements.
                  </li><li>Programming concepts and the Software Development Lifecycle (SDLC).
                  </li><li>
                  Maintaining knowledge of the principles and practices of software development best practices.
                  </li><li>Trouble shooting Web service communication issues across integrated systems or on Ecommerce web sites.</li></ul>
                  </div></div></div><h6 ><b>Qualifications
                  </b></h6><div><div><div><ul><li>Bachelor's degree in Information Technology or related field</li><li>
                  2 years of overall IT experience working with .NET C# development framework creating Web applications</li><li>
                  Working knowledge of Javascript frameworks are a plus</li><li>
                  Experience in integrating any payment gateway to web sites a plus</li><li>
                  Excellent verbal and written communication skills.</li><li>
                  Ability to multitask and troubleshoot issues quickly.</li></ul></div></div></div></div></div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-6  wow bounceInUp" data-wow-duration="1.4s">
          <div class="box" style="padding: 20px">
           
            <h4 class="title" ><a>Marketing Manager</a></h4>
            <div class="description">
                <div ><div><h6 ><b>Overview
                  </b></h6><div><div><div><div>We are looking for anMarketing Manager who is passionate about marketing strategy and execution.
                     In this role, you will be responsible for the highly targeted, multi-touch, and all marketing functions
                      and third party vendors work cohesively and execute with precision.</div><div></div><br>
                      <h6 ><b>Responsibilities
                        </b></h6>
                  <ul><li>
                  Manage and scale integrated direct marketing programs including planning, vendor management, execution, and measurement.</li><li>
                  Partake in the program planning process to find high quality multi-dimensional pieces that result in engagement for decision makers and economic buyers of target accounts</li><li>
                  Forecast resource needs for programs and closely track expenses.</li><li>
                  Collaborate with third party vendors to ensure assets are accurate and highly personalized</li><li>
                  Create and maintain program project plans and establish RACI matrices for all key steps</li><li>
                  Manage and execute all logistics and handling for direct mail</li><li>
                  Support Marketing’s Rhythm of Business (ROB) processes to review monthly campaign impact</li></ul>
                  </div></div></div>
                  <h6 ><b>Qualifications
                    </b></h6>
                  <div><div><div><ul><li>Minimum of Bachelor’s degree in marketing</li><li>
                  2+ years of experience – preferably in B2B technology industry</li><li>
                  Ability to deliver results in a fast-paced, high-growth environment</li><li>
                  Ability to work with a geographically distributed team</li><li>
                  Proven track record of organization skills and meticulous attention to detail
                  </li></ul>
                  </div></div></div>
                  
                </div><div></div></div>
            </div>
          </div>
        </div>
        
       

      </div>

    </div>
  </section><!-- #services -->